import { gql } from '@apollo/client';

export const UPDATE_CONSULTATION_ATTACHMENT = gql`
  mutation updateConsultationAttachment($input: UpdateConsultationAttachmentInput!) {
    consultation: updateConsultationAttachment(input: $input) {
      id
    }
  }
`;
